import { Season } from '../../types'
import { fetchSeasons } from '../../services/seasons.service'
import createBaseStore from '../createStoreHelper'
import { getters } from './season.getters'

export const SeasonModule = createBaseStore<Season>({
  resourceName: 'season',
  apiCalls: {
    fetchAllApiCall: fetchSeasons
  }
})

SeasonModule.getters = { ...SeasonModule.getters, ...getters }
